const STORAGE_KEY_SUFFIX = 'awaitingOrderWindowDays';
const DEFAULT_DAYS = '14';

export const getAwaitingWindowStorageKey = (userInfo) => {
  if (!userInfo || !userInfo.current_tenant || !userInfo.name) {
    return STORAGE_KEY_SUFFIX;
  }
  return `${userInfo.current_tenant}-${userInfo.name}-${STORAGE_KEY_SUFFIX}`;
};

export const saveAwaitingWindowPreference = (userInfo, days) => {
  try {
    const storageKey = getAwaitingWindowStorageKey(userInfo);
    localStorage.setItem(storageKey, days);
    return true;
  } catch (error) {
    console.error('Error saving awaiting window preference:', error);
    return false;
  }
};

export const loadAwaitingWindowPreference = (userInfo) => {
  try {
    const storageKey = getAwaitingWindowStorageKey(userInfo);
    const stored = localStorage.getItem(storageKey);
    if (stored && !isNaN(Number(stored)) && Number(stored) > 0) {
      return stored;
    }
    return DEFAULT_DAYS;
  } catch (error) {
    console.error('Error loading awaiting window preference:', error);
    return DEFAULT_DAYS;
  }
};
